<div class="position-relative" (mouseenter)="onHoverStart()" (mouseleave)="onHoverEnd()" (focusout)="onFocusOut($event)">
  <ng-container *ngTemplateOutlet="videoContent"></ng-container>
  <div
    #focusableCard
    class="video-detail-container"
    role="button"
    [attr.aria-label]="videoItemAriaLabel"
    [attr.tabindex]="tabIndex !== null ? tabIndex : 0"
    (keydown.enter)="onCardKeydown($event)"
    (keyup.enter)="onCardKeyup($event, video)"
    (keyup.space)="videoClicked(video, $event)"
  >
    <ng-container *ngTemplateOutlet="videoDetailContent"></ng-container>
  </div>
</div>
<ng-template #videoContent>
  <fui-card
    [title]="video.title"
    [image]="video.image"
    imageAsBackground="true"
    (titleClick)="videoClicked(video, $event)"
    (imageClick)="videoClicked(video, $event)"
    [progress]="contentService.userLearnData.videos[video.id]?.progress || '0'"
  >
    <ng-container *ngTemplateOutlet="videoMetadata"></ng-container>
    <ng-container *ngTemplateOutlet="hoverActions"></ng-container>
  </fui-card>
</ng-template>

<ng-template #videoDetailContent>
  <div class="video-detail-preview-wrapper" [class.previewing]="!!youtubePreviewUrl">
    @if (youtubePreviewUrl) {
      <div class="youtube-preview-layer" aria-hidden="true">
        <iframe
          class="youtube-preview-iframe"
          [src]="youtubePreviewUrl"
          [title]="'video.video_preview' | translate"
          frameborder="0"
          allow="autoplay; encrypted-media; picture-in-picture"
          referrerpolicy="strict-origin-when-cross-origin"
        ></iframe>
      </div>
    }

    <fui-card
      [title]="video.title"
      [image]="video.image"
      imageAsBackground="true"
      (titleClick)="videoClicked(video, $event)"
      (imageClick)="videoClicked(video, $event)"
      [progress]="contentService.userLearnData.videos[video.id]?.progress || '0'"
    >
      <ng-container *ngTemplateOutlet="videoMetadata"></ng-container>
      <ng-container *ngTemplateOutlet="hoverActions"></ng-container>
    </fui-card>
  </div>
</ng-template>

<ng-template #videoMetadata>
  <div class="sub-data">
    <div class="d-flex align-items-center justify-content-between">
      <ul class="list-inline video-metadata m-t-5">
        <li class="list-inline-item video-metadata-item">
          <p class="mb-0">
            <span class="sr-only">{{ "video.video_duration" | translate }}</span>
            {{ helperService.hhmmss(video.duration, true) }}
          </p>
        </li>
        @if (showDate) {
          <li class="list-inline-item video-metadata-item">
            <p class="mb-0">
              <span class="sr-only">{{ "video.creation_date" | translate }}</span>
              {{ video.created | date: undefined : false : false : true }}
            </p>
          </li>
        }
        @if (contentService.myVideoNotesByVideoId[video.id] && contentService.myVideoNotesByVideoId[video.id].length && !selectable) {
          <li class="list-inline-item video-metadata-item">
            <p class="mb-0" [attr.aria-label]="'video.you_have_notes_on_video' | translate">
              <span class="sr-only">{{ "video.you_have_notes_on_video" | translate }}</span>
              {{ "video.includes_notes" | translate }}
            </p>
          </li>
        }
        @if (video.subscription_only) {
          <li class="list-inline-item video-metadata-item">
            <p class="mb-0">{{ env.studioOnePlusBrandName }} {{ "video.subscribers_only" | translate }}</p>
          </li>
        }
        @if (video.level) {
          <li class="list-inline-item video-metadata-item">
            <p class="mb-0">
              <span class="sr-only">{{ "video.video_level" | translate }}</span>
              {{ contentService.levels[video.level].toUpperCase() }}
            </p>
          </li>
        }
        @if (admin || showAdd || showRemove) {
          <li class="list-inline-item video-metadata-item">
            <p class="mb-0">
              <span class="sr-only">{{ "video.video_id" | translate }}</span>
              ID {{ video.id }}
            </p>
          </li>
        }
        @if (admin) {
          <li class="list-inline-item video-metadata-item">
            <p class="mb-0">
              <span class="sr-only">{{ "video.platform_id" | translate }}</span>
              {{ "video.platform_id" | translate }} {{ video.platform_id }}
            </p>
          </li>
        }
      </ul>

      <div class="d-flex">
        @if (video.brand == "fender" || video.brand == "both") {
          <myp-svg id="fender-headstock" class="svg-red" width="20" height="20"></myp-svg>
        }
        @if (video.brand == "presonus" || video.brand == "both") {
          <myp-svg id="microphone" class="svg-blue" width="20" height="20"></myp-svg>
        }
      </div>
    </div>
    @if (admin || showAdd || showRemove) {
      <div class="admin-video-metadata video-metadata">
        <span class="small-btn m-0">{{ video.platform | sentenceCase }}</span>
        @if (video.subscription_only) {
          <span class="video-metadata-item blue m-r-5">{{ "video.subscribers_only" | translate }}</span>
        }
        <button
          class="small-btn"
          type="button"
          [attr.tabindex]="optionsTabIndex"
          [class.green]="video.status == 'approved'"
          [class.orange]="video.status == 'pending'"
          [class.red]="video.status == 'ignored'"
          [ngbTooltip]="video.status == 'approved' ? ('video.click_to_unapprove' | translate) : ('video.click_to_approve' | translate)"
          (click)="toggleApprove($event)"
        >
          {{ video.status | sentenceCase }}
        </button>
        @if (showAddToLesson) {
          <span class="small-btn blue m-x-5" (click)="addTo($event)">{{ "video.add_to" | translate }}</span>
        }
      </div>
    }
  </div>
</ng-template>

<ng-template #hoverActions>
  <div class="hover-actions">
    <ul class="list-inline video-metadata m-t-5">
      <li class="list-inline-item video-metadata-item">
        <div class="btn-group" role="group">
          <button
            type="button"
            class="video-action-btn m-r-10"
            [attr.tabindex]="optionsTabIndex"
            [ngbTooltip]="'video.copy_link' | translate"
            (click)="$event.stopPropagation(); copyLink(video, $event)"
          >
            <fa-icon [icon]="copied ? 'check' : 'link'"></fa-icon>
            <span class="sr-only">{{ "video.copy_link_sr" | translate }}</span>
          </button>
          @if (!admin && !showAdd && !showRemove && showLibraryActions) {
            <button
              type="button"
              class="video-action-btn"
              [attr.tabindex]="optionsTabIndex"
              [ngbTooltip]="contentService.userLearnData.videos[video.id]?.saved ? ('video.remove_from_library' | translate) : ('video.add_to_library' | translate)"
              (click)="$event.stopPropagation(); pin($event)"
            >
              @if (loadingLibraryAction) {
                <fa-icon icon="spinner" animation="spin"></fa-icon>
              }
              @if (!loadingLibraryAction) {
                <fa-icon [icon]="contentService.userLearnData.videos[video.id]?.saved ? 'minus' : 'plus'" aria-hidden="true"></fa-icon>
              }
              <span class="sr-only">{{ contentService.userLearnData.videos[video.id]?.saved ? ("video.remove_from_library" | translate) : ("video.add_to_library" | translate) }}</span>
            </button>
          }

          @if (showKeepWatchingActions) {
            <button
              type="button"
              class="video-action-btn"
              [attr.tabindex]="optionsTabIndex"
              [ngbTooltip]="'video.remove_from_keep_watching' | translate"
              (click)="$event.stopPropagation(); removeFromKeepWatching()"
            >
              @if (loadingLibraryAction) {
                <fa-icon icon="spinner" animation="spin"></fa-icon>
              }
              @if (!loadingLibraryAction) {
                <fa-icon icon="minus" aria-hidden="true"></fa-icon>
              }
              <span class="sr-only">{{ "video.remove_from_keep_watching" | translate }}</span>
            </button>
          }
        </div>
      </li>
    </ul>
    @if (video.tags?.length) {
      <ul class="list-inline video-tags m-t-5" role="list" aria-label="tags">
        @for (tag of video.tags; track tag) {
          <li class="list-inline-item">
            <button type="button" class="small-btn m-0" [attr.tabindex]="optionsTabIndex" (click)="$event.stopPropagation(); selectTag(tag, $event)">#{{ tag.title }}</button>
          </li>
        }
      </ul>
    }
  </div>
</ng-template>
